
export const formatMonetary = (value: number | string): string => {
    let valueAux: string = String(value);
    if (!String(value).includes('.')) {
        valueAux = Number(valueAux).toFixed(2).replace('.', '.');
    }
    return `${parseFloat(valueAux).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`;
}